import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PopUpAlert, PopUpAlertProvider } from './components/PopUpAlert';
import "./locale/languageChange";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <React.StrictMode>
    <Provider store={store}>
      <PopUpAlertProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*"
              element={
                <>
                  <PopUpAlert />
                  <App />
                </>} />
          </Routes>
        </BrowserRouter>
      </PopUpAlertProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
